export const INDICATOR_STYLE = { color: "#333" };
